import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FleetTrackingQuotesWrapper from "@components/layouts/fleetTrackingQuotesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <FleetTrackingQuotesWrapper>
            <PrivacyPolicy
                category="Fleet Trackers"
                domain="FleetTrackingQuotes.com"
            />
        </FleetTrackingQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
